import { misc, util } from "@/common/theme";
import { SectionTitle } from "@/components/SectionTitle";
import ShuffledText from "@/mono/components/ShuffledText";
import { mediaMobile } from "@/mono/lib/responsive";
import { setTypography } from "@/mono/lib/styles/mixins";
import SplitText from "mono/components/SplitText";
import styled from "styled-components";

export const SmallTextSplit = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: row nowrap;

  gap: 50rem;
  p {
    ${setTypography("smallParagraph")}
  }

  ${mediaMobile(`
    flex-flow: column nowrap;
    gap: 50rem;
  `)}
`;

export default function WhatWeDoServiceHeader({
  service,
  serviceBottom,
  children,
  className,
  fitTextHeader = { widthOnly: true },
  fullServiceName = null,
  showSectionTitle = true,
  sectionTitle = null,
}) {
  return (
    <>
      {showSectionTitle && (
        <SectionTitle>
          {sectionTitle
            ? sectionTitle
            : `What we do - ${fullServiceName ? fullServiceName : service}`}
        </SectionTitle>
      )}
      <HeaderWrapper className={className}>
        <div className="service-header__left">
          <SplitText
            tag="h1"
            animateOnScroll
            animation="charClipped"
            fitText={fitTextHeader}
          >
            {service}
          </SplitText>
          {serviceBottom && (
            <SplitText tag="h1" animateOnScroll fitText={fitTextHeader}>
              {serviceBottom}
            </SplitText>
          )}

          <ShuffledText
            wrapperClassName="shuffled-text-left"
            useRandomText
            animateOnScroll
          ></ShuffledText>

          <ShuffledText
            wrapperClassName="shuffled-text-right"
            useRandomText
            animateOnScroll
          ></ShuffledText>
        </div>
        <div className="service-header__right">{children}</div>
      </HeaderWrapper>
    </>
  );
}

const HeaderWrapper = styled.div`
  ${util.inner}

  display: flex;

  h1 {
    ${setTypography("floatingTitle")}
    color: ${({ theme }) => theme.theme.floatingTitle};
  }

  p {
    /* max-width: 800rem; */
  }

  /* p:nth-of-type(2) {
    margin-top: 50rem;
  } */

  .page-header__paragraph__section-break {
    margin-top: 80rem;
  }

  .service-header__left {
    width: ${misc.pageHalfWidth};
    position: relative;
  }

  .service-header__right {
    width: calc(100% - ${misc.pageHalfWidth});
  }

  .shuffled-text-left {
    left: 0;
    top: 70%;
  }

  .shuffled-text-right {
    right: 20%;
    top: 70%;
  }

  .txt-shuffle-wrapper {
    position: absolute;
    max-width: 400rem;
  }

  ${mediaMobile(`
    flex-direction: column;
    .service-header__left {
      width: 100%;
    }

    .service-header__right {
      width: 100%;
      margin-top: 150rem;
    }

    .shuffled-text-right {
    right: 10%;
    top: 30%;
  }
  `)}
`;
